import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { downloadInvoiceFile } from '../api/invoicesService'

export function useInvoiceFile(
  invoiceUuid: string | null,
  enabled = true,
): UseQueryResult<Blob, Error> {
  return useQuery<Blob, Error>({
    queryKey: ['invoices', 'file', invoiceUuid],
    queryFn: () => downloadInvoiceFile(invoiceUuid!),
    enabled: Boolean(invoiceUuid) && enabled,
    staleTime: 10 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
  })
}
